module.exports = __webpack_public_path__ + "img/4_gif.9c723b9b.gif";